/**
 * VendorCenter.jsx — public landing at /vendors.
 * Three cards: Marketing Agency / Startup Services / Startup Credit.
 * Each card has Apply + Login CTAs that deep-link to the right places.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Buildings, Briefcase, Bank, ArrowRight, SignIn } from '@phosphor-icons/react';

const TYPES = [
  { id: 'agency',   icon: Briefcase, color: '#6366f1', label: 'Marketing Agency',
    blurb: 'Get listed on the Founderboard Studios marketplace and run end-to-end engagements with founders.',
    applyTo: '/studio/apply',  loginHint: '/studio/login' },
  { id: 'service',  icon: Buildings, color: '#10b981', label: 'Startup Services',
    blurb: 'List LLP / GST / IP / compliance / hiring offerings and reach founders the moment they need them.',
    applyTo: '/services/apply', loginHint: '/services/login' },
  { id: 'credit',   icon: Bank,      color: '#f59e0b', label: 'Startup Credit',
    blurb: 'Surface corporate cards, working-capital loans, and bill-discounting products to qualified founders.',
    applyTo: '/credit/apply',   loginHint: '/credit/login' },
];

const VendorCenter = () => (
  <div className="min-h-screen bg-background text-text-primary p-6 md:p-10" data-testid="vendor-center">
    <div className="max-w-5xl mx-auto">
      <div className="mb-10">
        <div className="text-[10px] uppercase tracking-[0.24em] font-bold mb-2" style={{ color: '#6366f1' }}>Founderboard \u00b7 Vendor Center</div>
        <h1 className="text-4xl md:text-5xl font-heading font-bold mb-3" style={{ letterSpacing: '-0.025em' }}>Sell to <em className="not-italic" style={{ color: '#10b981' }}>thousands of Indian founders</em>.</h1>
        <p className="text-base text-text-secondary max-w-2xl">List your offering on Founderboard, get matched to founders that actually need it, and bill through our pipeline. Pick what you offer below to get started.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="vendor-center-cards">
        {TYPES.map((t) => {
          const Icon = t.icon;
          return (
            <div key={t.id} className="bg-surface border border-border rounded-2xl p-6 flex flex-col" data-testid={`vendor-center-card-${t.id}`}>
              <span className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: `${t.color}1a`, color: t.color }}>
                <Icon size={22} weight="fill" />
              </span>
              <h2 className="text-xl font-heading font-bold mb-1" style={{ letterSpacing: '-0.01em' }}>{t.label}</h2>
              <p className="text-sm text-text-secondary mb-5 flex-1">{t.blurb}</p>
              <div className="flex gap-2">
                <Link to={t.applyTo} data-testid={`vendor-center-apply-${t.id}`} className="flex-1 inline-flex items-center justify-center gap-1 px-3 py-2.5 rounded-lg text-sm font-semibold text-white" style={{ backgroundColor: t.color }}>
                  Sign up <ArrowRight size={11} weight="bold" />
                </Link>
                <Link to={t.loginHint} data-testid={`vendor-center-login-${t.id}`} className="inline-flex items-center justify-center gap-1 px-3 py-2.5 rounded-lg text-sm font-semibold border border-border hover:border-text-primary">
                  <SignIn size={11} weight="bold" /> Log in
                </Link>
              </div>
            </div>
          );
        })}
      </div>

    <p className="text-[11px] text-text-muted mt-8 text-center">Once approved, you&rsquo;ll get an email with a magic link to set your password &mdash; no need to come back to this page.</p>
    </div>
  </div>
);

export default VendorCenter;
